import { Component, Input } from '@angular/core';

@Component({
  selector: 'now-wbsuche-lib-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  imports: []
})
export class ChipComponent {
  @Input()
  name?: string;

  @Input()
  icon!: string;

  /**
   * Einzeln stehender Chip sollen nicht die Rolle List-Item erhalten.
   */
  @Input()
  single: boolean = false;
}
